import gql from 'graphql-tag';

export const DELETE_INVOICE_DOCUMENT = gql`
  mutation DeleteInvoiceDocument($id: ID!) {
    deactivateDocument(id: $id)
  }
`;
